import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    BANNERS_WIDGET,
    HORSE_RACING_WIDGET,
    GREYHOUND_RACING_WIDGET,
    CAROUSEL_WIDGET,
    BETFEED_WIDGET,
    POPULAR_WIDGET,
    INPLAY_WIDGET,
    FOOTBALL_SPORT_WIDGET,
    AMERICAN_FOOTBALL_SPORT_WIDGET,
    BASEBALL_SPORT_WIDGET,
    GAA_FOOTBALL_SPORT_WIDGET,
    GAA_HURLING_SPORT_WIDGET,
    RUGBY_LEAGUE_SPORT_WIDGET,
    RUGBY_UNION_SPORT_WIDGET,
    TENNIS_SPORT_WIDGET,
    TABLE_TENNIS_SPORT_WIDGET,
    DARTS_SPORT_WIDGET,
    CRICKET_SPORT_WIDGET,
    SNOOKER_SPORT_WIDGET,
    BASKETBALL_SPORT_WIDGET,
    BOXING_SPORT_WIDGET,
    MMA_SPORT_WIDGET,
    ICE_HOCKEY_SPORT_WIDGET,
    VOLLEYBALL_SPORT_WIDGET,
    HANDBALL_SPORT_WIDGET,
    RECALL_WON_WIDGET,
    RECALL_BACKED_WIDGET,
    RECALL_TRENDING_WIDGET,
    RECALL_PREFIX_WIDGET,
    BETFINDER_WIDGET,
    ESPORTS_WIDGET,
    TROTTING_WIDGET,
    HOMEPAGE_LOCATION,
    SPECIALS_WIDGET,
    XSELL_WIDGET,
    BADMINTON_WIDGET,
    POKER_BLAST_WIDGET,
    AUSTRALIAN_RULES_WIDGET,
    GOLF_SPORT_WIDGET,
} from './constants';
import { isPokerBlocked, onFavouriteSportWasUpdated } from '~shared/utils/user';
import { reorderWidgets } from './utils';
import {
    isPokerDisabledOnAndroid,
    isPokerDisabledOnIOS,
    isPokerBlastBlacklistedInBrand,
} from '~shared/utils/widgets';

import Banners from '~spa/Components/Banners';
import BetFinderLauncher from '~spa/Components/BetFinder/Launcher';
import RecallWidget from '~scenes/recall/widget';
import InplayWidget from '~scenes/inplaywidget';
import RacingWidget from '~scenes/racingwidget/app';
import BetFeedWidget from '~scenes/betfeed/widget';
import PopularWidget from '~scenes/popularwidget';
import SportsWidget from '~shared/components/react/SportsWidget';
import CarouselIcons from '~spa/Components/CarouselIcons';
import XsellWidget from '~spa/Components/XsellWidget';
import PokerBlastWidget from '~spa/Components/PokerBlastWidget';
import SpecialsWidget from '~shared/components/react/SpecialsWidget';
import GolfWidget from '~spa/Components/GolfWidget';

const Homepage = ({isLoggedIn}) => {
    const [widgetsOrder, setWidgetOrder] = useState([]);
    const [favouriteSportsWidgets, setFavouriteSportsWidgets] = useState([]);

    useEffect(() => {
        const updateOrder = () => {
            const {
                widgetOrder,
                favouriteWidgets,
            } = reorderWidgets();
            setWidgetOrder(widgetOrder);
            setFavouriteSportsWidgets(favouriteWidgets);
        };
        updateOrder();

        // the onFavouriteSportWasUpdated function returns a function that when called, will unsubscribe.
        const unsubscribe = onFavouriteSportWasUpdated(updateOrder);

        return () => {
            unsubscribe();
        };
    }, []);

    return (
        <>
            {
                widgetsOrder.map((widget) => {
                    const isFavouriteSport = favouriteSportsWidgets.includes(widget);
                    switch (widget) {
                        case BANNERS_WIDGET:
                            return <Banners key={widget} />;

                        case HORSE_RACING_WIDGET:
                            return <RacingWidget key={widget} widgetType={'horse-racing'} showHeader={true} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport}/>;

                        case GREYHOUND_RACING_WIDGET:
                            return <RacingWidget key={widget} widgetType={'greyhound-racing'} showHeader={true} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport}/>;

                        case TROTTING_WIDGET:
                            return <RacingWidget key={widget} widgetType={'trotting'} showHeader={true} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport}/>;

                        case CAROUSEL_WIDGET:
                            return <CarouselIcons key={widget} source={HOMEPAGE_LOCATION} />;

                        case BETFEED_WIDGET:
                            return <BetFeedWidget key={widget} />;

                        case POPULAR_WIDGET:
                            return <PopularWidget key={widget} source={HOMEPAGE_LOCATION} />;

                        case INPLAY_WIDGET:
                            return <InplayWidget key={widget} isShowFooter={true} source={HOMEPAGE_LOCATION}/>;

                        case BETFINDER_WIDGET:
                            return <BetFinderLauncher key={widget} />;

                        case FOOTBALL_SPORT_WIDGET:
                        case AMERICAN_FOOTBALL_SPORT_WIDGET:
                        case BASEBALL_SPORT_WIDGET:
                        case GAA_FOOTBALL_SPORT_WIDGET:
                        case GAA_HURLING_SPORT_WIDGET:
                        case RUGBY_LEAGUE_SPORT_WIDGET:
                        case RUGBY_UNION_SPORT_WIDGET:
                        case TENNIS_SPORT_WIDGET:
                        case TABLE_TENNIS_SPORT_WIDGET:
                        case DARTS_SPORT_WIDGET:
                        case CRICKET_SPORT_WIDGET:
                        case SNOOKER_SPORT_WIDGET:
                        case BASKETBALL_SPORT_WIDGET:
                        case BOXING_SPORT_WIDGET:
                        case MMA_SPORT_WIDGET:
                        case ICE_HOCKEY_SPORT_WIDGET:
                        case VOLLEYBALL_SPORT_WIDGET:
                        case HANDBALL_SPORT_WIDGET:
                        case ESPORTS_WIDGET:
                        case BADMINTON_WIDGET:
                        case AUSTRALIAN_RULES_WIDGET:
                            return <SportsWidget key={widget} sport={widget} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport}/>;

                        case RECALL_WON_WIDGET:
                        case RECALL_BACKED_WIDGET: {
                            const type = widget.replace(RECALL_PREFIX_WIDGET, '');

                            return isLoggedIn ? <RecallWidget key={widget} type={type} /> : null;
                        }
                        case RECALL_TRENDING_WIDGET: {
                            const type = widget.replace(RECALL_PREFIX_WIDGET, '');

                            return <RecallWidget key={widget} type={type} />;
                        }
                        case SPECIALS_WIDGET:
                            return <SpecialsWidget key={widget} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport} />;

                        case XSELL_WIDGET:
                            return <XsellWidget key={widget}/>;

                        case GOLF_SPORT_WIDGET:
                            return <GolfWidget key={widget} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport}/>;

                        case POKER_BLAST_WIDGET:
                            if (
                                isPokerBlocked()
                                || isPokerDisabledOnAndroid()
                                || isPokerDisabledOnIOS()
                                || isPokerBlastBlacklistedInBrand()
                             ) {
                                return null;
                            }

                            return <PokerBlastWidget key={widget}/>;

                        default:
                            return null;
                    }
                })
            }
        </>
    );
};

Homepage.propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
};

export default Homepage;
